import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@gestor-web/@core/auth/service';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
    template: '',
    standalone: false
})
export class LogoutComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store,
  ) {}

  ngOnInit() {
    this.store
      .select(UserProfileSelectors.selectLoginClienteIdp)
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe(clienteIdp => {
        let redirectUri = window.location.origin;
        if (clienteIdp) {
          redirectUri += '/cliente/' + clienteIdp;
        }
        this.authService.logout(redirectUri);
      });
  }

  private ngDestroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
}
